import script from "./AddBalise.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBalise.vue?vue&type=script&setup=true&lang=js"

import "./AddBalise.vue?vue&type=style&index=0&id=fe48c026&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe48c026"]])

export default __exports__